import { render, staticRenderFns } from "./NotificationYellowAlertIcon.vue?vue&type=template&id=5762c6fe&"
import script from "./NotificationYellowAlertIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationYellowAlertIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports